import './index.css'
import {Route, Switch} from 'wouter'
import {AuthProvider, Private} from '@/hooks/auth-provider'
import {LoginForm} from '@/components/login-form'
import {Dashboard} from '@/components/dashboard'

export function App() {
  return (
    <AuthProvider>
      <Switch>
        <Route path='/signin'>
          <LoginForm className='w-100' />
        </Route>
        <Private>
          <Dashboard />
        </Private>
        <Route>404: No such page!</Route>
      </Switch>
    </AuthProvider>
  )
}

export default App
